<template>
  <div>
    <div class="px-md-12 px-lg-12 pr-4 pt-12">
      <div class="mb-4">
        <span class="my-title">
          Olá, precisamos de algumas Informações <br />
          Será Rápido!
        </span>
      </div>

      <v-form ref="form" class="mt-16">
        <v-row dense class="ma-0 pa-0">
          <v-col cols="12" sm="12" md="8" lg="8">
            <strong>Nome</strong>
            <v-text-field
              :rules="rules"
              v-model="proponente.name"
              class="input-field"
              background-color="#f5f5f5"
              outlined
              placeholder="Preenchido"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <strong>CPF</strong>
            <v-text-field
              v-model="proponente.cpf"
              class="input-field"
              background-color="#f5f5f5"
              v-mask="['###.###.###-##']"
              :rules="[
                (v) => !v || TestaCPF(v) || 'CPF Inválido',
                (v) => !!v || 'Campo obrigatório',
              ]"
              outlined
              placeholder="Preenchido"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <strong>Data de nascimento</strong>
            <v-text-field
              v-model="proponente.dataNascimento"
              prepend-inner-icon="mdi-calendar-today"
              :rules="[(v) => !v || TestDate(v) || 'Data Inválida']"
              class="input-field"
              background-color="#f5f5f5"
              outlined
              v-mask="['##/##/####']"
              placeholder="Preenchido"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <strong>Número de filhos</strong>
            <v-text-field
              v-model="proponente.numeroFilhos"
              min="0"
              type="number"
              no-data-text="Nenhum dado disponivel"
              :rules="[
                (v) => !!v || 'Campo obrigatório',
                (v) => v >= 0 || 'Valor deve ser positivo',
              ]"
              class="input-field"
              background-color="#f5f5f5"
              outlined
              placeholder="Preenchido"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <strong>Valor da renda mensal</strong>

            <v-currency-field
              v-model="proponente.valorRenda"
              :rules="[
                (v) => !!v || 'Campo obrigatório',
                (v) => parseFloat(v) > 0 || 'Valor deve ser acima de zero',
              ]"
              class="input-field"
              background-color="#f5f5f5"
              outlined
              placeholder="Preenchido"
            >
              <template v-slot:prepend-inner>
                <span class="mt-1"> R$ </span>
              </template>
            </v-currency-field>
          </v-col>
        </v-row>
      </v-form>
    </div>

    <div class="mb-6 mr-2 d-flex justify-end">
      <v-btn
        class="next-button"
        @click="submit"
        elevation="0"
        width="161"
        height="44"
      >
        <strong
          style="color: var(--custom-white-second-color)"
          class="mr-2 next-button-label"
        >
          Prosseguir
        </strong>
        <v-icon style="color: var(--custom-white-second-color)"
          >mdi-arrow-right-circle-outline</v-icon
        >
      </v-btn>
    </div>
  </div>
</template>

<style>
.my-title {
  font-weight: normal;
  font-size: 31px;
  line-height: 36px;
  letter-spacing: 0.15px;
  color: #39424e;
  display: flex;
  justify-content: center;
}

.input-field {
  box-sizing: border-box;
  border-radius: 6px;
}

.input-field fieldset {
  border: 1px solid #b9b9b9;
  box-sizing: border-box;
  border-radius: 6px;
}

.next-button {
  background-color: var(--custom-primary-color) !important;
}

.next-button:hover {
  opacity: 0.7;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.next-button::before {
  opacity: 0.7;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

input::-webkit-calendar-picker-indicator {
  display: none;
}

.next-button-label {
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #ffffff;
}

@media (max-width: 800px) {
  .my-title {
    font-size: 24px;
  }
}
</style>

<script>
import { VMoney } from "v-money";
import ApiService from "../../../../services/ApiService";
import moment from "moment";
import { saveSessionInfo } from "../../../../services/CoverService";

export default {
  name: "PessoalInfo",
  props: {
    socio: Object,
  },

  data: () => ({
    coberturas: [],
    rules: [(v) => !!v || "Campo obrigatório"],
    document: "",
    birthday: "",
    gender: "",
    sonsNumber: "",
    smoker: "",
    job: "",
    income: "",
    retiree: "",
    liberal: "",
    proponente: {
      pessoaFisica: {
        required: ["cpf", "dataNascimento", "sexo", "aposentado"],
        cpf: "",
        dataNascimento: "",
        sexo: "",
        aposentado: 0,
      },
    },
    jobOptions: [],
    retireeOptions: [
      {
        text: "Não",
        value: "nao",
      },
      {
        text: "Aposentado por Tempo de Serviço/Idade",
        value: "portempo",
      },
      {
        text: "Aposentado por Invalidez por Doença",
        value: "invalidezpordoenca",
      },
      {
        text: "Aposentado por Invalidez por Acidente",
        value: "invalidezporacidente",
      },
    ],
    genders: [
      {
        text: "Masculino",
        value: 0,
      },
      {
        text: "Feminino",
        value: 1,
      },
    ],
    covers: [],
    apiService: new ApiService(),
    money: {
      decimal: ",",
      thousands: ".",
      precision: 2,
      masked: false,
    },
  }),

  directives: { money: VMoney },

  created() {
    const storagedData = localStorage.getItem("@GlobusVida:data");

    if (storagedData) {
      const parsedData = JSON.parse(storagedData);

      this.proponente.name = parsedData.name;
      this.proponente.cpf = parsedData.cpf;
      this.proponente.dataNascimento = moment(parsedData.dataNascimento).format(
        "DD/MM/YYYY"
      );
      this.proponente.numeroFilhos = parsedData.numeroFilhos;
      this.proponente.valorRenda = parsedData.valorRenda;
    }
  },

  methods: {
    TestaCPF(strCPF) {
      strCPF = strCPF.replace(/\D/g, "");
      var Soma;
      var Resto;
      Soma = 0;
      if (strCPF == "00000000000") return false;

      for (let i = 1; i <= 9; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;
      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(9, 10))) return false;
      Soma = 0;
      for (let i = 1; i <= 10; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(10, 11))) return false;
      return true;
    },

    TestDate(date) {
      const dateArray = date.split("/");

      let day = dateArray[0],
        month = dateArray[1],
        year = dateArray[2];

      let dayLimit;
      let month31 = ["01", "03", "05", "07", "08", "10", "12"];
      if (month === "02") {
        dayLimit = 28;
      } else if (month31.includes(month)) {
        dayLimit = 31;
      } else {
        dayLimit = 30;
      }

      day = dateArray[0] >= 1 && dateArray[0] <= dayLimit ? true : false;
      month = dateArray[1] >= 1 && dateArray[1] <= 12 ? true : false;
      year =
        dateArray[2] >= 1952 && dateArray[2] <= new Date().getFullYear()
          ? true
          : false;

      return day && month && year;
    },

    async submit() {
      if (this.$refs.form.validate()) {
        const reverseDate = this.proponente.dataNascimento
          .split("/")
          .reverse()
          .join("/");
        const age = Math.floor(
          Math.ceil(
            Math.abs(new Date(reverseDate).getTime() - new Date().getTime()) /
              (1000 * 3600 * 24)
          ) / 365.25
        );

        if (age < 18 || age > 70) {
          this.$toast.error(
            "Produto somente disponível para pessoas entre 18 e 70 anos"
          );

          return;
        }

        const model = {
          name: this.proponente.name,
          cpf: this.proponente.cpf,
          dataNascimento: moment(this.proponente.dataNascimento, "DD/mm/yyyy"),
          numeroFilhos: this.proponente.numeroFilhos,
          valorRenda: this.proponente.valorRenda,
          id_corretor: this.$route.query.pf,
          id_parceiro: this.$route.query.pc,
        };

        localStorage.setItem("@GlobusVida:data", JSON.stringify(model));
        await saveSessionInfo({
          name: model.name,
          cpf: model.cpf,
          quoted: true,
        });
        this.$emit("save", model);
      }
    },
  },
};
</script>
